export const trim = (str, char = ' ') => {
  /*test case: 
     let testStr =  ' -  - companyName - companySiteName - companyTypeName - ';
     let result = trim (testStr, ' - ');
    */
  if (str) {
    //between trim
    while (str.indexOf(`${char}${char}`) >= 0) {
      str = str.replace(`${char}${char}`, char);
    }

    //head trim
    if (str.indexOf(char) === 0) {
      str = str.substr(char.length);
    }

    //tail trim
    if (str.lastIndexOf(char) === str.length - char.length) {
      str = str.substr(0, str.length - char.length);
    }
  }

  return str;
};
